import {useEffect} from 'react'
import {useSearchParams, useParams} from 'react-router-dom'

import useFetch from 'shared/model/useFetch'
import useAlertModalAtom from 'shared/model/useAlertModalAtom'
import getApiRolePath from 'shared/utils/getApiRolePath'
import useRoleCookie from 'shared/model/useRoleCookie'

const useGetExamPaymentList = () => {
	const [searchParams] = useSearchParams()
	const page = searchParams.get('page')
	const search = searchParams.get('search')
	const {idx} = useParams()

	const [fetchResult, fetchRequest, isLoading] = useFetch()
	const [, setAlert] = useAlertModalAtom()
	const [userRole] = useRoleCookie()

	useEffect(() => {
		const rolePath = getApiRolePath(userRole)
		fetchRequest(
			'GET',
			`/${rolePath}/exam/${idx}/payment/list?page=${page}&search=${search || ''}`
		)
	}, [page, search])

	useEffect(() => {
		switch (fetchResult?.statusCode) {
			case 400:
				if (fetchResult?.data?.error_code === 'page')
					setAlert('페이지 번호 입력 양식을 확인해 주세요.')
				else if (fetchResult?.data?.error_code === 'search')
					setAlert('검색어 입력 양식을 확인해 주세요.')
				else if (fetchResult?.data?.error_code === 'exam_idx')
					setAlert('필기 시험 idx 입력 양식을 확인해 주세요.')
				else setAlert('입력한 값의 형식이 잘못되었습니다.')
				break
			case 404:
				if (fetchResult?.data?.error_code === 1)
					setAlert('필기 시험 데이터가 존재하지 않습니다.')
				break
		}
	}, [fetchResult])

	return [fetchResult, isLoading]
}

export default useGetExamPaymentList
